import axios from "infra/http";
import { useMutation } from "react-query";
import { ParceiroEndereco } from "../typings/index";


export default function useSaveEnderecoParceiro(id: string) {
  return useMutation(async (data: ParceiroEndereco) => {
    const { data: result } = await axios.put(`/v1/parceiro/${id}/endereco`, {
      ...data,
    });

    return result;
  });
}
